module.exports = __webpack_public_path__ + "img/31iKawYVsldFlibQv6hKhf.7b8b5670.svg";